import { Static, Type } from '@sinclair/typebox';
import { WebsiteScrapeModeSchema } from './website_scraper';

// Découverte d'URL : à partir de ce que le pro/lead nous dit de son commerce
// (« je suis sur Planity »), on retrouve les URLs à scraper.
// Cf. docs/website-preview-pulse-plan.md.

export const WebsiteDiscoveryRequestSchema = Type.Object({
  business_name: Type.String(),
  city: Type.Optional(Type.String()),
  // Plateformes citées par le pro : 'planity', 'treatwell', 'instagram', 'facebook'…
  platform_hints: Type.Optional(Type.Array(Type.String())),
});
export type WebsiteDiscoveryRequestObject = Static<typeof WebsiteDiscoveryRequestSchema>;

// Nature d'une source : conditionne le mode de scrape et la priorité au merge.
export const SourceKindSchema = Type.Union([
  Type.Literal('official'),
  Type.Literal('planity'),
  Type.Literal('treatwell'),
  Type.Literal('google'),
  Type.Literal('instagram'),
  Type.Literal('facebook'),
  Type.Literal('other'),
]);
export type SourceKind = Static<typeof SourceKindSchema>;

// Origine d'une source : Google Places, recherche web Serper, ou URL fournie par l'utilisateur.
export const FoundViaSchema = Type.Union([Type.Literal('places'), Type.Literal('serper'), Type.Literal('input')]);
export type FoundVia = Static<typeof FoundViaSchema>;

// Une source candidate, qualifiée et prête à être scrapée.
export const DiscoveredSourceSchema = Type.Object({
  url: Type.String({ format: 'uri' }),
  kind: SourceKindSchema,
  mode: WebsiteScrapeModeSchema,
  found_via: FoundViaSchema,
  // Nom lisible de l'établissement tel qu'il apparaît sur la source (titre du
  // résultat Serper, displayName Google Places). Permet à l'assistant de faire
  // confirmer au lead qu'on a trouvé le bon établissement AVANT de scraper.
  title: Type.Optional(Type.String()),
});
export type DiscoveredSourceObject = Static<typeof DiscoveredSourceSchema>;

export const WebsiteDiscoveryResultSchema = Type.Object({
  sources: Type.Array(DiscoveredSourceSchema),
});
export type WebsiteDiscoveryResultObject = Static<typeof WebsiteDiscoveryResultSchema>;
